import * as React from "react";
import {useState} from "react";
import {imageBaseUrl} from "config";
import "./index.scss";
import {COLOR} from "utils/variables";
import { compressImage } from "utils/imageConversion";

export enum DocTypes {
    SELFIE = "SELFIE",
    PAN = "PAN",
    PAY_SLIP_1 = "PAY_SLIP_1",
    AADHAAR = "AADHAAR",
    AADHAAR_FRONT = "AADHAAR_FRONT",
    AADHAAR_BACK = "AADHAAR_BACK",
    CURRENT_ADDRESS_PROOF = "CURRENT_ADDRESS_PROOF",
    RENTAL_AGREEMENT = "RENTAL_AGREEMENT",
    OFFER_LETTER = "OFFER_LETTER",
    OTHER = "OTHER",
    CURR_ADDR_PROOF = "CURR_ADDR_PROOF",
    PAY_SLIP = "PAY_SLIP",
    SIGNED_CHEQUE = "SIGNED_CHEQUE",
    CANCELLED_CHEQUE = "CHEQUE",
    NACH = "NACH",
}
interface IProps {
    type: DocTypes | string;
    primaryLabel: string;
    handleFileInput?: (Base64: string, DocTypes: string, isEncrypt?: boolean) => void;
    secondaryLabel?: string;
    errorMsg?: string;
    backgroundColor?: string;
    acceptType?: string;
    isUploaded?: boolean;
    compressionRequired?: boolean;
    captureType?: string;
}
const imageSizeLimit = 3000000;
const listOfFileType = new Set([
    "application/pdf",
    "image/jpg",
    "image/jpeg",
    "image/png",
]);

export const getBase64 = (e, fileSelected, type, handleFileInput, compressReq) => {
    const files = e.target.files;
    if (files.length > 0) {
        fileSelected(files);
        const fr = new FileReader();
        if (compressReq && files[0].type.includes("image") && files[0].size > imageSizeLimit) {
        const compressedFile: Promise<File> = compressImage(files[0]);
        compressedFile.then((data) => {
            fr.onload = (evt) => {
                const b64 = window.btoa((evt.target as any).result);
                handleFileInput(b64, type);
            };
            fr.readAsBinaryString(data);
        });
    } else {
        fr.onload = (evt) => {
            const b64 = window.btoa((evt.target as any).result);
            const isEncrypt = (evt.target as any).result.includes("Encrypt");
            handleFileInput(b64, type, isEncrypt);
        };
        fr.readAsBinaryString(files[0]);
        }
    }
};

export const DocInput = (props: IProps) => {
    const [error, setError] = useState<string>(null);
    const fileInputRef = React.useRef(null);
    const [file, fileSelected] = React.useState(null);
    const style = {
        height: props.secondaryLabel ? 71 : 47,
        backgroundColor: props.backgroundColor ? props.backgroundColor : COLOR.PURPLE,
        borderRadius: 6,
        width: "100%",
        color: COLOR.WHITE,
    };
    const primaryLabelStyle = {
        fontSize: !props.secondaryLabel ? 18 : 14,
    };

    const onChangeHandle = (e: React.ChangeEvent<HTMLInputElement>) => {
        setError(null);
        if (!listOfFileType.has(e.target.files[0].type)) {
            let list = [];
            listOfFileType.forEach((i) => list.push(i.split("/")[1]));
            setError(`Allowed file type ${list.join("/")}.`);
            return;
        }
        getBase64(e, fileSelected, props.type, props.handleFileInput, props.compressionRequired);
    }
    return (<>
        <div style={style} onClick={() => fileInputRef.current.click()}>
            <input
                ref={fileInputRef}
                type="file"
                onChange={onChangeHandle}
                style={{display: "none"}}
                accept={props.acceptType}
                capture={props.captureType ? props.captureType : null}
                id ={`${props.type}`}
                />
            <div className="doc-input-container">
                <div className="left-container">
                    {!file ?
                        <div className="label-container">
                            <div style={primaryLabelStyle} className="primary-label">
                                {props.primaryLabel}
                            </div>
                            {props.secondaryLabel ?
                                <div className="secondary-label">
                                    {props.secondaryLabel}
                                </div> : null}
                        </div>
                        :
                        <div className="file-selected-container">
                            <div className="selected-text">
                                {file[0].name.slice(0, 25)}
                            </div>
                        </div>
                    }
                    {props.isUploaded &&
                        <div className="icon" style={{paddingRight: 5}}>
                        <img src={`${imageBaseUrl}/img/icons/green_tick.png`} alt="upload"/>
                        </div>
                    }
                </div>
                <div className="right-container">
                    <img src={`${imageBaseUrl}/img/icons/upload_icon.png`} alt="upload"/>
                </div>
            </div>
        </div>
        {error && <div className="error-msg">{error}</div>}
    </>);
};

DocInput.defaultProps = {
  acceptType: ".pdf,image/*",
};
export default DocInput;
